import React from 'react';

const CreditTab = ({ handleTabChange, errors, handleInputChange, state }) => {
    return (
        <div className="tab-pane fade show active">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Request Credit Amount *</label>
                        <input
                            type="number"
                            className={`form-control ${errors.creditAmount ? 'is-invalid' : ''}`}
                            placeholder="Enter Request Credit Amount"
                            name="creditAmount"
                            value={state.creditAmount}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.creditAmount && <div className="invalid-feedback">{errors.creditAmount}</div>}
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Request Credit Days *</label>
                        <input
                            type="number"
                            className={`form-control ${errors.creditDays ? 'is-invalid' : ''}`}
                            placeholder="Enter Request Credit Days"
                            name="creditDays"
                            value={state.creditDays}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.creditDays && <div className="invalid-feedback">{errors.creditDays}</div>}
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Finance Email *</label>
                        <input
                            type="text"
                            className={`form-control ${errors.financeEmail ? 'is-invalid' : ''}`}
                            placeholder="Enter Finance Email"
                            name="financeEmail"
                            value={state.financeEmail}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.financeEmail && <div className="invalid-feedback">{errors.financeEmail}</div>}
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Finance Phone Number *</label>
                        <input
                            type="number"
                            className={`form-control ${errors.financePhone ? 'is-invalid' : ''}`}
                            placeholder="Enter Phone Number"
                            name="financePhone"
                            value={state.financePhone}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.financePhone && <div className="invalid-feedback">{errors.financePhone}</div>}
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="form-group mb-3">
                        <label>Credit Amount Remark *</label>
                        <textarea
                            type="text"
                            className={`form-control ${errors.credit_amount_remark ? 'is-invalid' : ''}`}
                            placeholder="Enter credit amount remark"
                            value={state.credit_amount_remark}
                            onChange={handleInputChange}
                            name='credit_amount_remark'
                            required
                        ></textarea>
                        {errors.credit_amount_remark && (
                            <div className="invalid-feedback">
                                {errors.credit_amount_remark}
                            </div>
                        )}
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="form-group mb-3">
                        <label>Credit Days Remark *</label>
                        <textarea
                            type="text"
                            className={`form-control ${errors.credit_days_remark ? 'is-invalid' : ''}`}
                            placeholder="Enter credit days remark"
                            value={state.credit_days_remark}
                            onChange={handleInputChange}
                            name='credit_days_remark'
                            required
                        ></textarea>
                        {errors.credit_days_remark && (
                            <div className="invalid-feedback">
                                {errors.credit_days_remark}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-end align-items-center mt-4">
                <button
                    type="button"
                    className="btn btn-dark btn-sm mr-3"
                    onClick={() => handleTabChange("bank")}
                >
                    Back
                </button>

                <button
                    type="button"
                    className="btn btn-info btn-sm"
                    onClick={() => handleTabChange("security")}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default CreditTab;